<template>
  <div>
    <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add">
      <v-card-text>
        <v-form ref="form" v-model="valid" style="margin-top:10px">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <trans-select2
                  v-model="item"
                  propertyName="Term"
                  :items="terms"
                  :label="$t('headers.hourshistory.employer_contribution_term')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :displayFunc="(item, str) => `${str} ${item.Year}`"
                ></trans-select2>
              </v-col>
              <v-col cols="12" md="6">
                <no-autocomplete-textfield
                  :label="$t('headers.hourshistory.hours')"
                  v-model="item.Amount"
                  :class="'required'"
                  :rules="[$rules.requiredNum, $rules.decimal]"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  @blur="amountBlur"
                ></no-autocomplete-textfield>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <trans-enum
                  :value.sync="item.Code"
                  :items="options.Enums.Reason"
                  :label="$t('headers.hourshistory.reason_code')"
                  class="required"
                  :rules="[$rules.required]"
                ></trans-enum>
              </v-col> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn
          :disabled="!valid || noSickDaySettings"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
    <v-dialog
      v-model="sickDayWarning"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="science"
      >
        <v-card-text>
          {{ $t("components.memberview.sick_day_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="sickDayWarning=false">
            {{ $t("globals.ok") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransSelect2 from "@/components/TransSelect2";
import TransEnum from "@/components/TransEnum.vue";
export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect2,
    TransEnum,
  },
  props: {
    item: {
      default: () => ({
        MemberId: "",
        PlanId: "",
        EmployerId: this.employerId,
        TermId: "",
        Amount: "",
        CreatedAt: "",
        ChangedAt: null,
      }),
    },
    title: String,
    employerId: String,
    memberGroupIdentityId:String
  },
  data: () => ({
    valid: true,
    error: null,
    saving: false,
    terms: [],
    sickDayWarning:false,
    noSickDaySettings:false
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
  },
  methods: {
    ...mapActions("plansMembers", [
      "addMemberHours",
      // "updateMemberHours",
      "getHourTerms",
      "getSickHourBankSettingsByEffectiveDate"
    ]),
    async save() {
      this.error = null;
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.item));
        if (item.Term) {
          item.TermId = item.Term.Id;
          delete item.Term;
        }
        item.Amount = parseFloat(item.Amount); //.toFixed(2);
        
          item.CreatedAt = this.$helpers.nowFormatted();
          item.Code = "Accepted";
          await this.addMemberHours({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: item.MemberId,
            payload: {
              HourReport: item,
            },
          });
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      }
      this.saving = false;
    },
    isNumeric(evt) {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      if (
        iKeyCode != 46 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57) &&
        (iKeyCode < 96 || iKeyCode > 105)
      )
        return false;

      return true;
    },
    currencyKeyUp(evt) {
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      if (!value) return;
      if (
        value === "-0" ||
        value === "-0." ||
        value === "-0.0" ||
        value === "-0.00"
      ) {
        return;
      }
      let decimal = parseFloat(value);
      if (isNaN(decimal)) {
        return;
      }
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = decimal.toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
    },
    currencyKeydown(evt, sender) {
      console.log(evt);
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      console.log(value);
      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else {
        if (value !== "-" && value.indexOf(".") == -1) {
          var start = el.selectionStart;
          el.value = value + ".00";
          el.setSelectionRange(start, start);
        }
      }
      value = el.value;
      if (evt.keyCode == 190 || evt.keyCode == 110) {
        if (value.indexOf(".") >= 0) {
          el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
          evt.preventDefault();
        }
        return;
      }
      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    amountBlur() {
      let num = parseFloat(this.item.Amount).toFixed(2);
      if (!isNaN(num)) {
        this.item.Amount = num;
      }
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.terms = (await this.getHourTerms({
        planIdentityId: this.selectedPlan.Id,
        employerId: this.employerId,
      })).data.value;
      if (this.planIdentity.HasSickPaymentBank) {
        const now = new Date();
        let day = now.getDate() + 1;
        let month = now.getMonth();
        if (day.toString().length === 1) day = "0" + day.toString();
        if (month.toString().length === 1) month = "0" + month.toString();
        const date =
          now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
        const sickDayBankSettings = (
          await this.getSickHourBankSettingsByEffectiveDate({
            planIdentityId: this.selectedPlan.Id,
            effectiveDate: date,
            payload: {
              MemberGroupIdentityId: this.memberGroupIdentityId
                ? this.memberGroupIdentityId
                : "00000000-0000-0000-0000-000000000000",
            },
          })
        ).data;
        if (sickDayBankSettings === null || sickDayBankSettings === undefined) {
          this.noSickDaySettings = true;
          this.sickDayWarning = true;
        }
      }
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  },
  watch: {},
};
</script>
